import React from 'react';
import {styled} from 'baseui';
import {Theme} from 'baseui/theme';
import {Button} from 'baseui/button';
import {Spinner} from 'baseui/spinner';

const OrderWrapper = styled('div', () => ({
  display: 'flex',
}));

const StyledMenuButton = ($theme: Theme, small: boolean) => ({
  padding: '10px 30px',
  fontSize: small ? '14px' : '19px',
  fontWeight: 700,
  width: small ? '120px' : '180px',
  backgroundColor: $theme.colors.accent,
  border: '2px solid transparent',
  borderRadius: '24px',
  whiteSpace: 'nowrap',
  transition: '500ms ease',
  ':hover': {
    background: $theme.colors.backgroundPrimary,
    borderColor: $theme.colors.accent,
    color: $theme.colors.accent,
  },
  [$theme.mediaQuery.small]: {
    width: small ? '100px' : '180px',
  },
});

const ButtonTextWrapper = styled('div', () => ({
  flexDirection: 'column',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
}));

const ButtonTitle = styled('p', () => ({
  margin: 0,
}));

const ButtonSymbolWrapper = styled('div', () => ({
  display: 'flex',
  margin: '0 0 2px 8px',
  justifyContent: 'center',
  alignItems: 'center',
}));

type OrderNowAndQuantityProps = {
  onOrderPress?: () => any;
  isLoading: boolean;
  buttonTitle: string;
  theme: Theme;
  small?: boolean;
};

export default function OrderNowButton({
  onOrderPress,
  buttonTitle,
  theme,
  isLoading,
  small = false,
}: OrderNowAndQuantityProps) {
  return (
    <OrderWrapper>
      <Button
        onClick={onOrderPress}
        overrides={{
          BaseButton: {style: ({$theme}) => StyledMenuButton($theme, small)},
        }}
      >
        <ButtonTextWrapper>
          <ButtonTitle>{buttonTitle}</ButtonTitle>
        </ButtonTextWrapper>
        {isLoading ? (
          <ButtonSymbolWrapper>
            <Spinner
              $size={small ? 14 : 20}
              color={theme.colors.backgroundPrimary}
            />
          </ButtonSymbolWrapper>
        ) : null}
      </Button>
    </OrderWrapper>
  );
}
